import rootReducer from '@/redux/reducers/root';
import { configureStore, PreloadedState } from '@reduxjs/toolkit';
import { emptySplitApi } from './base-api';
import { Config } from '@/services';
import { apiMiddleware } from '@/redux/middleware/api.ts';

export function setupStore(reducer: any = rootReducer, preloadedState?: PreloadedState<RootState>) {
	return configureStore({
		reducer,
		devTools: Config.isDev(),
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false
			}).concat(emptySplitApi.middleware, apiMiddleware as any),
		preloadedState
	});
}

const store = setupStore();

export default store;
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
